var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmptyStateEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "95px",
    viewBox: "0 0 98 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEmptyStateEvent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M220.818303,277 C230.292428,277 238,284.787787 238,294.360171 L238,334.018499 C238,342.849823 231.440166,350.162088 222.984297,351.241179 L222.984297,368.528021 C222.984297,369.932645 222.146929,371.198112 220.862838,371.735296 C220.437832,371.913339 219.991383,372 219.548782,372 C218.654234,372 217.775631,371.647525 217.118053,370.982849 L197.714832,351.378669 L157.181697,351.378392 C147.707572,351.378392 140,343.590883 140,334.018499 L140,294.360171 C140,284.787787 147.707572,277 157.181697,277 L220.818303,277 Z M212.731675,302 L161.481659,302 C159.558947,302 158,303.788929 158,305.996 C158,308.202751 159.558947,309.992 161.481659,309.992 L212.731675,309.992 C214.654386,309.992 216.213333,308.202751 216.213333,305.996 C216.213333,303.788929 214.654664,302 212.731675,302 Z M212.731675,320.648 L161.481659,320.648 C159.558947,320.648 158,322.436929 158,324.644 C158,326.851071 159.558947,328.64 161.481659,328.64 L212.731675,328.64 C214.654386,328.64 216.213333,326.850751 216.213333,324.644 C216.213333,322.437249 214.654664,320.648 212.731675,320.648 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Events-----Empty-state",
    transform: "translate(-140.000000, -277.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icEmptyStateEvent",
    fillOpacity: 0.6,
    fill: "#666666",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyStateEvent);
export default __webpack_public_path__ + "static/media/icEmptyStateEvent.17434302d0289cb5c9992e6c42f4fe0f.svg";
export { ForwardRef as ReactComponent };